import { useRef } from "react"
import { v4 as uuid } from "uuid"

import { Icon } from "web/components"
import useDropDownMenu from "web/hooks/behaviour/useDropDownMenu"

export function LockIcon() {
  const { current: valueId } = useRef(uuid())

  const { DropDownMenu, menuVisible, toggleMenu } = useDropDownMenu({
    triggerElementId: `lockIcon_${valueId}`,
  })

  return (
    <>
      <div id={`lockIcon_${valueId}`}>
        <Icon
          outline
          name="lock-closed"
          width="16px"
          height="16px"
          className="ml-1 cursor-pointer"
          onClick={toggleMenu}
        />
      </div>
      {menuVisible && (
        <DropDownMenu transition={false}>
          <div className="value-view-tool-tip p-2.5 text-sm">
            The contents of this field can only be changed by Data Admins.
          </div>
        </DropDownMenu>
      )}
    </>
  )
}
